<template>
    <div class="user-stats">
        <v-row>
            <v-col>
                <v-card class="d-flex justify-center align-center pa-4 flex-column">
                    <div>Viser data for {{ presets[preset] === 0 ? 'i dag' : `de seneste ${presets[preset]} dage`}}</div>
                    <br />
                    <v-btn-toggle v-model="preset" mandatory>
                        <v-btn>
                            I dag
                        </v-btn>
                        <v-btn>
                            7 dage
                        </v-btn>
                        <v-btn>
                            14 dage
                        </v-btn>
                        <v-btn>
                            30 dage
                        </v-btn>
                    </v-btn-toggle>
                </v-card>
            </v-col>
            <v-col>
                <v-card class="d-flex justify-center align-center pa-4 flex-column">
                    <div>Viser kampagner med min. {{ minCount }} afsluttede</div>
                    <br />
                    <div class="min-count d-flex">
                        <div @click="decrementMinCount" class="decrement-min-count">
                            -
                        </div>
                        <div class="number">
                            {{ minCount }}
                        </div>
                        <div @click="incrementMinCount" class="increment-min-count">
                            +
                        </div>
                    </div>
                </v-card>
            </v-col>
            <v-col>
                <v-card class="d-flex justify-center align-center pa-4 flex-column">
                    <div>Viser {{ campaignFilter ? 'alle' : 'kun kvalificerede' }} kampagner</div>
                    <br />
                    <v-btn-toggle v-model="campaignFilter" mandatory>
                        <v-btn>
                            Kvalificerede
                        </v-btn>
                        <v-btn>
                            Alle
                        </v-btn>
                    </v-btn-toggle>
                </v-card>
            </v-col>
        </v-row>
        <loader v-if="loading" />
        <v-row v-else>
            <v-col cols="12">
                <v-card>
                    <div>
                        <v-col cols="12">
                            <v-row class="collapsed-inputs" align="center">
                                <v-col class="d-flex justify-center text--primary" cols="4">
                                    <v-text-field
                                        outlined
                                        clearable
                                        label="Søg på kampagnenavn"
                                        prepend-inner-icon="fa-search"
                                        v-model="searchString"
                                    />
                                </v-col>
                                <v-col class="d-flex justify-center text--primary" cols="4">
                                    <div class="text-center second" style="width: 100%">
                                        <div>Afdelingen</div>
                                    </div>
                                </v-col>
                                <v-col class="d-flex justify-center text--primary" cols="4">
                                    <div class="text-center third" style="width: 100%">
                                        <div>Mig</div>
                                    </div>
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-subheader>
                            <v-row>
                                <v-col :cols="subCols[subIndex]" v-for="(sub, subIndex) in fields" :key="subIndex" class="d-flex">
                                    <v-col v-for="(field, index) in sub" :key="index" :cols="field.cols"  class="d-flex justify-center">
                                        <div v-if="field.field" @click="setSort(field.field, subIndex)">
                                            {{ field.header }}
                                        </div>
                                        <div v-else>
                                            {{ field.header }}
                                        </div>
                                    </v-col>
                                </v-col>
                            </v-row>
                        </v-subheader>
                    </div>
                    <div class="d-flex">
                        <v-col :cols="subCols[subIndex]" v-for="(sub, subIndex) in fields" :key="subIndex">
                            <v-list>
                                <v-item-group>
                                    <v-list-item v-for="(campaign, index) in sortedCampaigns" :key="index">
                                        <v-list-item-content>
                                            <v-row align="center" style="height: 3rem">
                                                <v-col v-for="(field, index) in sub" :key="index" :cols="field.cols" class="d-flex" :class="field.class">
                                                    <div
                                                        v-if="field.header === 'Niveau'"
                                                        class="campaign-level"
                                                        :style="`background: ${$store.state.main.levelColors[campaign.level]}`"
                                                    >
                                                        {{ campaign.level + 1 }}
                                                    </div>
                                                    <div v-else v-line-clamp="1" :title="campaign.name">
                                                        {{ field.formatter(field.value(campaign)) }}                                        
                                                    </div>
                                                </v-col>
                                            </v-row>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-item-group>
                            </v-list>
                        </v-col>
                    </div>
                </v-card>
            </v-col>
        </v-row>
    </div>
</template>

<script>
export default {
    data () {
        return {
            level: null,
            searchString: null,
            presets: [0, 7, 14, 30],
            minCount: 0,
            preset: 2,
            campaignFilter: 0,
            loading: true,
            campaigns: null,
            sortDirection: false,
            sortField: 'userAvgLead',
            sortSub: 2,
            subCols: ['4', '4', '4'],
            fields: [
                [
                    {
                        header: 'Niveau',
                        value: campaign => campaign.level + 1,
                        formatter: this.$options.filters.separator,
                        cols: '2',
                        class: 'justify-center'
                    },
                    {
                        header: 'Kampagne',
                        value: campaign => campaign.name,
                        formatter: this.$options.filters.nameFilter,
                        cols: '10',
                        class: 'justify-start'
                    }
                ],
                [
                    {
                        header: 'Afsluttede',
                        field: 'departmentCount',
                        value: campaign => campaign.departmentStats.count,
                        formatter: this.$options.filters.separator,
                        cols: '4',
                        class: 'justify-center'
                    },
                    {
                        header: 'Hitrate',
                        field: 'hitrate',
                        value: campaign => campaign.departmentStats.count ? campaign.departmentStats.sales / campaign.departmentStats.count : (!!campaign.departmentStats.count * 1),
                        formatter: this.$options.filters.percentage,
                        cols: '4',
                        class: 'justify-center'
                    },
                    {
                        header: 'Salg pr. emne',
                        field: 'departmentAvgLead',
                        value: campaign => campaign.departmentStats.count ? campaign.departmentStats.total / campaign.departmentStats.count : 0,
                        formatter: this.$options.filters.separator,
                        cols: '4',
                        class: 'justify-center'
                    }
                ],
                [
                    {
                        header: 'Afsluttede',
                        field: 'userCount',
                        value: campaign => campaign.userStats.count,
                        formatter: this.$options.filters.separator,
                        cols: '4',
                        class: 'justify-center'
                    },
                    {
                        header: 'Hitrate',
                        field: 'hitrate',
                        value: campaign => campaign.userStats.count ? campaign.userStats.sales / campaign.userStats.count : (!!campaign.userStats.count * 1),
                        formatter: this.$options.filters.percentage,
                        cols: '4',
                        class: 'justify-center'
                    },
                    {
                        header: 'Salg pr. emne',
                        field: 'userAvgLead',
                        value: campaign => campaign.userStats.count ? campaign.userStats.total / campaign.userStats.count : 0,
                        formatter: this.$options.filters.separator,
                        cols: '4',
                        class: 'justify-center'
                    }
                ]
            ]
        }
    },
    computed: {
        uniqueId () {
            return this.$store.state.main.uniqueId
        },
        sortedCampaigns () {
            const fieldFunction = this.fields[this.sortSub].filter(header => header.field === this.sortField)[0].value
            let campaigns = this.campaigns
            const searchString = this.searchString ? this.searchString.replace(/[_\s]/gi, '').toLowerCase() : ''
            return campaigns.filter(campaign => {
                if (!campaign.name.replace(/[_\s]/gi, '').toLowerCase().includes(searchString)) return null
                if (this.campaignFilter === 0) return campaign.level <= this.level && campaign.userStats.count >= this.minCount
                else return campaign.userStats.count >= this.minCount
            }).sort((a, b) => {
                if (this.sortDirection === false) return fieldFunction(a) > fieldFunction(b) ? -1 : 1
                else return fieldFunction(a) < fieldFunction(b) ? -1 : 1
            })
        },
        days () {
            return this.presets[this.preset]
        }
    },
    methods: {
        backgroundClass (subIndex) {
            const classMap = ['first', 'second', 'third']
            return classMap[subIndex]
        },
        async getData () {
            this.loading = true
            const response = await this.$http().get(`user/${this.uniqueId}/stats`, {
                params: {
                    days: this.days
                }
            })
            this.campaigns = response.data.stats
            this.level = response.data.userLevel
            this.loading = false
        },
        setSort (field, subIndex) {
            if (this.sortField === field) this.sortDirection = !this.sortDirection
            else {
                this.sortSub = subIndex
                this.sortField = field
            }
        },
        decrementMinCount () {
            this.minCount -= 5
            if (this.minCount < 0) this.minCount = 0
        },
        incrementMinCount () {
            this.minCount += 5
        }
    },
    watch: {
        days: function () {
            this.getData()
        }
    },
    created () {
        this.getData()
    }
}
</script>

<style lang="scss">
.user-stats {
    .v-list-item:nth-child(odd) {
        background: #f4f4f4;
    }
    .min-count {
        height: 48px;
        border-top: 1px !important;
        border-bottom: 1px !important;
        border-style: solid !important;
        border-color: #ccc !important;
        border-radius: 5px;
        background: #ccc;
        width: 120px;

        .number {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 60px;
            background: white;
        }

        .decrement-min-count, .increment-min-count {
            -webkit-touch-callout: none; /* iOS Safari */
            -webkit-user-select: none; /* Safari */
            -khtml-user-select: none; /* Konqueror HTML */
            -moz-user-select: none; /* Old versions of Firefox */
            -ms-user-select: none; /* Internet Explorer/Edge */
            user-select: none; /* Non-prefixed version, currently supported by Chrome, Edge, Opera and Firefox */
            height: 100%;
            width: 30px;
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;
        }
    }
    .second, .third {
        border: 1px solid #ccc;
        border-radius: 5px;
        padding: 15px 16px;
    }
    .second {
        background: rgba(0, 255, 255, 0.5);
    }
    .third {
        background: rgba(0, 255, 0, 0.5);
        border-left: 0;
        border-right: 0;
    }
    .campaign-level {
        display: flex;
        justify-content: center;
        align-items: center;
        color: white;
        width: 20px;
        height: 20px;
        border-radius: 5px;
    }
}
</style>